const Footer = () => {
    return(
        <footer>
            <div className="footerCloud">
                <p>Created at <a href="https://www.junocollege.com/" target="_blank" rel="noreferrer">Juno College</a> by</p> 

                <p><a href="https://courtfolio.ca" target="_blank" rel="noreferrer">Court</a>, <a href="https://joegencarelli.com" target="_blank" rel="noreferrer">Joe</a>, <a href="https://www.kianaomoerah.com/" target="_blank" rel="noreferrer">Kiana</a> & <a href="https://robpetrungaro.com" target="_blank" rel="noreferrer">Rob</a></p>
                
                <p>API by <a href="https://sunrise-sunset.org" target="_blank" rel="noreferrer">Sunrise Sunset</a></p>
            </div>
        </footer>
    )
}

export default Footer;